var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 653,
    height: 193,
    viewBox: "0 0 653 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.242 192.236C42.2668 192.236 0.521973 168.763 0.521973 123.137C0.521973 77.5108 42.2668 54.0382 108.242 54.0382C174.086 54.0382 215.962 77.5108 215.962 123.137C215.962 168.763 174.086 192.236 108.242 192.236ZM108.242 151.752C142.086 151.752 155.254 139.753 155.254 123.137C155.254 106.522 142.086 94.5217 108.242 94.5217C74.3985 94.5217 61.2298 106.522 61.2298 123.137C61.2298 139.753 74.3985 151.752 108.242 151.752Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.374 54.0382C390.584 54.0382 422.584 69.4668 422.584 107.445V189.071H366.353L365.958 170.082C352.789 183.928 325.003 192.236 294.584 192.236C249.547 192.236 224.658 177.599 224.658 149.906C224.658 125.115 242.831 114.829 270.748 109.159C296.822 103.884 328.164 101.379 363.851 100.588C361.349 92.1481 352.131 87.1371 328.164 87.1371C301.958 87.1371 291.818 92.1481 290.238 100.192H231.637C233.876 68.0162 265.744 54.0382 327.374 54.0382ZM311.44 157.818C340.543 157.818 364.51 146.082 364.51 132.236V126.961C340.279 128.412 319.868 130.522 306.04 133.027C291.818 135.665 285.234 139.621 285.234 146.214C285.234 154.258 294.452 157.818 311.44 157.818Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M581.411 189.071L538.086 138.698L504.506 163.225V189.071H445.773V0.236023H504.506V109.423L569.954 57.2031H651.337L581.016 108.763L652.522 189.071H581.411Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOak);
export default __webpack_public_path__ + "static/media/oak.10d68e07a013c25d59ac6626a73c520a.svg";
export { ForwardRef as ReactComponent };